import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Collection } from './components/Collection';
import { HowItWorks } from './components/HowItWorks';
import { Bonuses } from './components/Bonuses';
import { OfferStack } from './components/OfferStack';
import { InsidePreview } from './components/InsidePreview';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-full w-full bg-cream font-body text-ink" data-id="element-0" data-mp="31agq8u4rwpm3">
      <CountdownBar data-id="element-1" data-mp="31ctaxf1x1e2u" />
      <Hero data-id="element-2" data-mp="2wka20ve6b74d" />
      <main data-id="element-3" data-mp="2wjgq7g0cxrfd">
        <Problems data-id="element-4" data-mp="2wiyx2s8zrtbo" />
        <Collection data-id="element-5" data-mp="2wiffxdr618yp" />
        <HowItWorks data-id="element-6" data-mp="2whxabqim5ie4" />
        <Bonuses data-id="element-7" data-mp="28ufm24yk52fw" />
        <OfferStack id="offer" title="Here's Everything Included Today" priceLabel="🔥 Your price today" savingsLabel="🎉 Save $58 today" ctaLabel="Yes! Give Me the Complete Kit for $27 →" data-id="element-8" data-mp="28tw972nrl48q" />
        <InsidePreview data-id="element-9" data-mp="3ijpef4c7z5bc" />
        <Testimonials data-id="element-10" data-mp="3mlj82snzz920" />
        <OfferStack id="checkout" title="Everything Included With Your Order" priceLabel="🔥 Get everything today for" savingsLabel="🎉 That's $58 in savings" ctaLabel="I want the complete kit →" tone="dark" data-id="element-11" data-mp="3mkrd9k285fcs" />
        <Faq data-id="element-12" data-mp="2zl3dbpgpde7f" />
      </main>
      <Footer data-id="element-13" data-mp="2zlv8iz6e19x6" />
    </div>;
}